import { render, staticRenderFns } from "./MarketList.vue?vue&type=template&id=a11663e6&scoped=true"
import script from "./MarketList.vue?vue&type=script&lang=js"
export * from "./MarketList.vue?vue&type=script&lang=js"
import style0 from "./MarketList.vue?vue&type=style&index=0&id=a11663e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a11663e6",
  null
  
)

export default component.exports